import { styled } from "@mui/material/styles";

export const StyledActionButton = styled("button")(
  ({
    $h,
    $px,
    $fs,
    $gap,
    $background,
    $color,
    $border,
    $boxShadow,
    $fontWeight,
    $fullWidth,
  }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: $gap,
    height: $h,
    padding: `0 ${$px}px`,
    borderRadius: 10,
    fontSize: $fs,
    fontFamily: "Poppins, sans-serif",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "transform 150ms,filter 200ms",
    background: $background,
    color: $color,
    border: $border,
    boxShadow: $boxShadow,
    fontWeight: $fontWeight,
    flex: $fullWidth ? 1 : undefined,
    "&:hover": {
      transform: "translateY(-1px)",
      filter: "brightness(1.08)",
    },
  }),
);
